import { combineReducers } from 'redux';

import persistReducer from 'redux-persist/es/persistReducer';
import { rootPersistConfig } from './persistConfig';

import { reducer as cartReducer } from './ducks/cart';
import { reducer as authReducer } from './ducks/auth';
import { reducer as permReducer } from './ducks/perm';

const rootReducer = combineReducers({ auth: authReducer, cart: cartReducer, perm: permReducer });

export default persistReducer(rootPersistConfig, rootReducer);
